import { CubeRequestConfig } from "../../../common/interface/cube-request-config.interface";

export interface GetSelfWorkingSessionsRequestDto {
  params: {
    startDate: string;
    endDate: string;
  };
  config: CubeRequestConfig;
}
